<div class="ls-card" *ngIf="scriptNode" [class.locked]="scriptNode.locked">
    <div class="ls-top">
        <div class="ls-meta">
            <span class="ls-step">Step {{ scriptNode.step }} of {{ TOTAL_STEPS }}</span>
            <span class="ls-phase">{{ scriptNode.phase }}</span>
        </div>
        <span class="ls-lock">Locked wording</span>
    </div>
    <div class="track-dots">
        <i *ngFor="let s of stepList" [class.on]="s <= scriptNode.step"></i>
    </div>
    <div class="ls-body">
        <div class="ls-label">Say now</div>
        <p class="ls-say" [innerHTML]="fillScript(scriptNode.say)"></p>
        <p class="ls-cue" *ngIf="scriptNode.cue">{{ scriptNode.cue }}</p>
    </div>
    <div class="ls-actions" *ngIf="prevNode || scriptNode.next">
        <button type="button" class="ls-back" *ngIf="prevNode" (click)="prevStep()">Back</button>
        <button type="button" class="ls-next" *ngIf="scriptNode.next" (click)="nextStep()">Next</button>
    </div>
</div>
